var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.65C3.91667 7.68333 3.825 7.7 3.725 7.7C3.625 7.7 3.53333 7.68333 3.45 7.65C3.36667 7.61667 3.28333 7.55833 3.2 7.475L0.225 4.475C0.0749999 4.325 0 4.14583 0 3.9375C0 3.72917 0.0749999 3.55 0.225 3.4C0.375 3.25 0.554166 3.17917 0.7625 3.1875C0.970833 3.19583 1.14167 3.26667 1.275 3.4L3.725 5.85L9.35 0.225C9.5 0.0749999 9.67917 0 9.8875 0C10.0958 0 10.275 0.0749999 10.425 0.225C10.575 0.375 10.6458 0.558333 10.6375 0.775C10.6292 0.991667 10.5583 1.16667 10.425 1.3L4.25 7.475C4.16667 7.55833 4.08333 7.61667 4 7.65Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndi);
export default __webpack_public_path__ + "static/media/Indi.ccd01d7ddfe3cbc2772c1c3eb9a776ee.svg";
export { ForwardRef as ReactComponent };